import React from 'react'
import { useApiContext } from "../../hooks/useApiContext";
import QRCode from "react-qr-code";
import { Row, Col } from 'antd';
import './styles.css'
import stamp1 from "../../assets/stamp1.png";
import stamp2 from "../../assets/stamp2.png"
import { useState } from 'react';
import moment from "moment";

const InvoicePrint = React.forwardRef((props, ref) => {
  const { items, barcode } = useApiContext();
  let image;
  console.log("Barcode value from print", barcode);
  if (props.stampImage == 1) {
    image = <img src={stamp1} style={{width: "25%" ,height: "35px"}} />
  } else if(props.stampImage == 2){
    image = <img src={stamp2} style={{width: "25%" ,height: "35px"}} />;
  } else {
    image =''
  }
  return (
    <div ref={ref} >
      <div style={{ marginTop: '40px', position: 'relative', padding: '0px 30px' }}>
        <h2 style={{ textAlign: 'center' }}>TAX Invoice <br />
          فاتورة ضريبة  </h2>
        <Row>
          <Col span={12}>
            <h2>Invoice Details</h2>
            <p>
              <b>Invoice Duration:</b> {`${moment(props.startDate).format("YYYY-MM-DD")} - ${moment(props.endDate).format("YYYY-MM-DD")}`}
            </p>
            <p>
              <b> رقم الفاتورة <br />
                Invoice No:</b> {props.invoiceNo}
            </p>
            <p>
              <b>
                تاريخ الفاتورة  <br />
                Invoice Date:</b> {moment(props.invoiceDate).format("YYYY-MM-DD")}
            </p>
            <p>{
              props.customField1 ?
                <>
                  {props.customField1}: <b>{props.customField2}</b>
                </>
                :
                ""
            }

            </p>


          </Col>
          <Col span={10}>
            <h2 className="text-right">Project Details</h2>
            <p className="text-right">
              <b>Project Name: </b> {props.projectData ? props.projectData.projectName : ""}
            </p>
            <p className="text-right">
              <b>VAT No:</b>  {props.itemInvoice.project.vatNumber}
            </p>
            {image}

            <p className="text-right">
              {
                props.customField3 ?
                  <>
                    {props.customField3}: <b>{props.customField4}</b>
                  </>
                  :
                  ""
              }
            </p>
            <p className="text-right">
              {
                props.customField5 ?
                  <>
                    {props.customField5}: <b>{props.customField6}</b>
                  </>
                  :
                  ""
              }
            </p>
          </Col>
          {items && (
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td>
                    البند
                    <br />
                    ITEMS
                  </td>
                  <td>
                    الوصف
                    <br />
                    DESCRIPTION
                  </td>
                  <td>
                    السعر
                    <br />
                    PRICE
                  </td>
                  <td>
                    الكمية
                    <br />
                    QUANTITY
                  </td>
                  <td>
                    قيمة الضريبة
                    <br />
                    TOTAL AMOUNT
                  </td>
                  <td>
                    الاجمالي مع الضريبة
                    <br />
                    TOTAL AMOUNT WITH VAT
                  </td>
                </tr>
              </thead>
              <tbody>
                {items.map((item, i) => (
                  <>
                    <tr>
                      <td>{i == 0 ? 1 : i + 1}</td>
                      <td>
                        {" "}
                        <b>{item.description}</b>
                      </td>
                      <td>
                        <b>{item.price}</b>
                      </td>
                      <td>
                        <b>{item.quantity}</b>
                      </td>
                      <td>
                        <b>{(item.price * item.quantity).toFixed(2)}</b>
                      </td>
                      <td>
                        <b>
                          {item.withoutVat
                            ? (item.price * item.quantity).toFixed(2)
                            : (
                                item.amount +
                                item.price * item.quantity * 0.15
                              ).toFixed(2)}
                        </b>
                      </td>
                    </tr>
                  </>
                ))}
                <tr>
                  <td colSpan={5} className="text-right f-bold p-10">
                    الكمية الإجمالية
                    <br />
                    Total Quantity:
                  </td>
                  <td>{items.reduce((a, b) => a + b.quantity, 0)}</td>
                </tr>
                <tr>
                  <td colSpan={5} class="text-right f-bold p-10">
                    الاجمالي قبل الضريبة
                    <br />
                    Total before VAT:
                  </td>
                  <td>
                    {" "}
                    <b>
                      SR {items.reduce((a, b) => a + b.amount, 0).toFixed(2)}
                    </b>{" "}
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} class="text-right f-bold p-10">
                    الاجمالي بعد الضريبة
                    <br />
                    Total VAT Amount:
                  </td>
                  <td>
                    {" "}
                    <b>
                      SR{" "}
                      {items.length > 0
                        ? items[0].withoutVat
                          ? 0
                          : (
                              items.reduce((a, b) => a + b.amount, 0) * 0.15
                            ).toFixed(2)
                        : []}
                    </b>{" "}
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} class="text-right f-bold p-10">
                    الرصيد المستحق
                    <br />
                    Due Amount:
                  </td>
                  <td>
                    <b>
                      SR{" "}
                      {items.length > 0
                        ? items[0].withoutVat
                          ? items.reduce((a, b) => a + b.amount, 0).toFixed(2)
                          : (
                              items.reduce((a, b) => a + b.amount, 0) +
                              items.reduce((a, b) => a + b.amount, 0) * 0.15
                            ).toFixed(2)
                        : []}
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {props.itemInvoice.business &&
            <>
              <table className='table table-bordered' style={{ textAlign: 'left', width: '65%', border: '1px solid #ccc' }}>
                <thead>
                  <tr>
                    <td colSpan={2}>
                      Account details
                    </td>
                  </tr>
                </thead>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    Account Name
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.business.accountName}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    Account Number
                  </td>

                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.business.accountNumber}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    IBAN Number
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.business.iBanNumber}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    Bank Name
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.business.bankName}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    VAT Number
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.business.vatNumber}
                  </td>
                </tr>

              </table>
              <div style={{ margin: '60px auto', width: '30%', textAlign: 'center' }}>
                {
                  <QRCode value={props.itemInvoice.qrValue} size={150} />
                }

              </div>
            </>
          }


          {props.itemInvoice.businees &&
            <>
              <table className='table table-bordered' style={{ textAlign: 'left', width: '65%', border: '1px solid #ccc' }}>
                <thead>
                  <tr>
                    <td colSpan={2}>
                      Account details
                    </td>
                  </tr>
                </thead>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    Account Name
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.businees.accountName}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    Account Number
                  </td>

                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.businees.accountNumber}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    IBAN Number
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.businees.iBanNumber}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    Bank Name
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.businees.bankName}
                  </td>
                </tr>
                <tr className="item">
                  <td style={{ fontWeight: 'bold' }}>
                    VAT Number
                  </td>
                  <td style={{ textAlign: 'left', padding: '10px' }}>
                    {props.itemInvoice.businees.vatNumber}
                  </td>
                </tr>

              </table>
              <div style={{ margin: '60px auto', width: '30%', textAlign: 'center' }}>
                {
                  barcode && <QRCode value={barcode} size={150} />
                  
                }
                
              </div>
            </>
          }

        </Row>
      </div>
    </div>
  )
})

export default InvoicePrint;

